import { Component, OnInit, Inject } from '@angular/core';
import { OverlayContainer } from '@angular/cdk/overlay';
import { Router, NavigationEnd } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'
import { Globals } from '../global/globals';

// write our own Bootstrap "affix" data spy:
// https://stackoverflow.com/questions/39452007/how-to-use-scrollspy-affix-in-angular-2

@Component({
    selector: 'te-header',
    templateUrl: 'teHeader.component.html',
    styles: [`

@media screen and (max-width: 700px) {
    .te-desktop-nav {
        display: none;  /* hide the desktop navigation menu when on a smaller screen width */
    }
}

@media screen and (min-width: 701px) {
    .te-mobile-nav {
        display: none;  /* hide the mobile navigation menu when on a larger screen width */
    }
}

.te-navbar-mobile {
    position: fixed;
    width: 100%;
    background-color: #747678;
    background-image: linear-gradient(to bottom, #747678 0, #545658 100%);
    min-height: 55px;
    top: 0;
    margin: 0;
    padding: 10px 20px;
    z-index: 10;
    color: #fafafa !important;
}
.te-nav-button {
    color: #fafafa !important;
    font-size: 13pt;
    text-align: left;
}

`],
    standalone: false
})
export class TEHeaderComponent implements OnInit {
    public loggedIn: boolean = false;
    public login: boolean = false;
    public showMenu: boolean = false;
    public availableLanguages: Language[];
    public darkMode: boolean = false;
    isNetworkIDUser: boolean = false;    
    isMFARegistered: boolean = false;
    isAppIdUser: boolean = false;

    constructor(private http: HttpClient, private router: Router,
        private readonly dialog: MatDialog, private globals: Globals,
        private userInfoService: UserInfoService,
        private readonly localStorage: LocalStorage,
        private readonly overlayContainer: OverlayContainer,
        private translate: TranslateService) {
        
    }

    ngOnInit(): void {



        this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                this.routerChange();
            }
        });
        this.routerChange();
        
        this.http.get<Language[]>('/api/site/languages').subscribe(result => {
            this.availableLanguages = result;
            this.availableLanguages.forEach(lng => {
                lng.culture = lng.culture.trim();  // why are these values padded with spaces?  
            });
        });

        var darkMode = this.localStorage.getItem('DarkMode');
        console.log(`Dark mode site setting is ${darkMode}`);
        if (darkMode === "true")
            this.toggleDarkMode();
        else if (!darkMode) {
            if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
                // dark mode based on device settings if the user hasn't selected it on our website yet:
                console.log("Turning on dark mode based on browser/device preferences");
                this.toggleDarkMode();
            }
        }

        if (this.globals.isLoggedIn()) {
            this.loadUserStatus();
        }
        // Also run when login succeeds later
        this.globals.loginSuccess$.subscribe(() => {
            this.loadUserStatus();
        });
    }

    public loadUserStatus(): void {
        this.userInfoService.isNetworkUser().subscribe(result => {
            if (result == true) {
                this.isNetworkIDUser = true;

            }
        });
        this.userInfoService.isAppIDUser().subscribe(result => {
            if (result == true) {
                this.isAppIdUser = true;

            }
        });
        this.userInfoService.getMFARegistrationDetailsForUser().subscribe(result => {
            if (result == true) {
                this.isMFARegistered = true;
                console.log("MFA-t", this.isMFARegistered);
            } else {

                this.isMFARegistered = false;
                console.log("MFA-f", this.isMFARegistered);
            }
        });

    }


    public routerChange(): void {
        if (window.location.pathname.includes('Login/Entry')) {
            this.loggedIn = false;
        }
        else if (window.location.pathname.includes('Login/LoginSecondFactor')) {
            this.login = true;
        }
        else if (window.location.pathname.includes('Login/PasswordResetPIN')) {
            this.login = true;
        }
        else if (window.location.pathname.includes('Login/UserIdMismatchError')) {
            this.login = true;
        }
        else {
            this.loggedIn = true;
        }
    }
    public toggleMenu(): void {
        this.showMenu = !this.showMenu;
    }

    public dismissMenu(): void {
        this.showMenu = false;
    }

    public signOut() {
        this.localStorage.removeItem('reverificationDialogShown');
        this.http.post('/api/Login/End', '{}').subscribe(result => {
            //if (result.status === 302 || result.status === 200) { // TBD..... Check with TOM for status code 302
                try {
                    window.location.replace("/Login");
                } catch (e) {
                    console.log("window.location.replace is not working: " + e);
                }
            //}
            return false;
        });
    }

    public setLanguage(): void {
        const dialogRef = this.dialog.open(LanguageDialogComponent, {
            data: {
                languages: this.availableLanguages
            },
            disableClose: true
        });

        dialogRef.updatePosition({ top: '100px' });
    }

    public toggleDarkMode(): void {
        this.darkMode = !this.darkMode;        
        if (this.darkMode) {
            
            this.localStorage.setItem('DarkMode', 'true');
            this.overlayContainer.getContainerElement().classList.add('dark-theme');
        }
        else {
            
            this.localStorage.setItem('DarkMode', 'false');
            this.overlayContainer.getContainerElement().classList.remove('dark-theme');
        }
        // If the Overlays aren't getting the dark-theme applied correctly, check that the theme.scss
        // is creating the alt-theme for our 'dark-theme' CSS class name, which should be right after
        // the main theme is initialized -> @include mat.all-component-themes($theme);
        // .dark-theme {        @include mat.all-component-themes($altTheme);    }


        document.body.classList.toggle('dark-theme');
    }

    public getToolTip() {
        if (this.darkMode) {
            // show tooltip as Enable Light Mode
            return this.translate.instant('LightModeToggleTxt');
        }
        // show tooltip as Enable Dark Mode

        return this.translate.instant('DarkModeToggleTxt');
    }

    openExternalLink() {
        window.open('https://mysignins.microsoft.com/security-info', '_blank');
    } 
}

import { Injectable, EventEmitter } from '@angular/core';
@Injectable()
export class HeaderEventService {
    public languageChanged: EventEmitter<any> = new EventEmitter();
}

import { TranslateService } from '@ngx-translate/core';
import { LocalStorage } from '../localStorage/localStorage.service';
import { UserInfoService } from '../../../../Main/services/userInfo/userInfo.service';
declare var document: any;
@Component({
    selector: 'language-dialog',
    templateUrl: 'language.dialog.html',
    standalone: false
})
export class LanguageDialogComponent {
    public isLoading: boolean;
    public languageCode: string;
    public languageOptions: Language[];

    constructor(
        private readonly http: HttpClient,
        public dialogRef: MatDialogRef<LanguageDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
        private readonly translate: TranslateService, private readonly headerEvent: HeaderEventService,
        private readonly localStorage: LocalStorage) {
        this.languageOptions = data.languages;
        if (document.language)
            this.languageCode = document.language;  // set current value.
    }

    public updateLanguage(): void {
        document.language = this.languageCode.trim();
        this.translate.use(document.language);
        this.headerEvent.languageChanged.emit(document.language);  // in case any components want to know
        this.localStorage.setItem("language", document.language);
        this.dialogRef.close();
    }
}


class Language {
    culture: string;
    cultureName: string;
}